/**
 * Created by user on 2020/7/3.
 */

import __root from '../__root';

export const file = `${__root}/.cache/cache.json`;

